// extracted by mini-css-extract-plugin
export default {"PhotoTitleEditForm__submitBtn":"iw_a bhe_sq","PhotoTitleEditForm__cancelBtn":"iw_b bhe_su bhe_st"};